export const getUserPerdiemRates = (state) => state.perdiemRates;

export const getPerdiemRates = (state) => state.perdiemRates;





